const STORAGE_KEY = 'geofleet_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export type Attribution = Partial<Record<(typeof UTM_KEYS)[number] | 'landing_page' | 'referrer', string>>;

function read(): Attribution | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Attribution) : null;
  } catch {
    return null;
  }
}

/**
 * Remembers how the visitor first arrived (UTMs, landing page, external referrer) so the
 * contact form can send it to HubSpot even if they browse a few pages first.
 * A new visit with UTMs replaces the stored first touch.
 */
export function captureAttribution(): void {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const utms: Attribution = {};
    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value) utms[key] = value.slice(0, 255);
    }
    const hasUtms = Object.keys(utms).length > 0;
    if (read() && !hasUtms) return;

    const referrer = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : '';
    const next: Attribution = {
      ...utms,
      landing_page: window.location.href.slice(0, 1000),
      ...(referrer ? { referrer: referrer.slice(0, 1000) } : {}),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* storage blocked: attribution is optional */
  }
}

export function getAttribution(): Attribution {
  return read() ?? {};
}
